module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column",
    attrs: {
      "id": "lista-de-solicitacoes"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filtros-escolhidos print"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.somenteFiltroDeSituacaoEstaSelecionado()),
      expression: "somenteFiltroDeSituacaoEstaSelecionado()"
    }],
    staticClass: "title-print"
  }, [_vm._v("\n        DEMONSTRATIVO DE SUBSÍDIOS\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "filtros-escolhidos-itens"
  }, [_c('ul', [_c('li', [_vm._v("\n            Projeto:\n            "), _c('span', [_vm._v(_vm._s(_vm.filtroDeProjetoSelecionado()))])]), _vm._v(" "), _c('li', [_vm._v("\n            Cidade: "), _c('span', [_vm._v(_vm._s(_vm.filtroDeCidadeSelecionado()))])]), _vm._v(" "), _c('li', [_vm._v("\n            Empreendimento:\n            "), _c('span', [_vm._v(_vm._s(_vm.filtroDeEmpreendimentoSelecionado()))])]), _vm._v(" "), _c('li', [_vm._v("\n            Situação: "), _c('span', [_vm._v(_vm._s(_vm.filtroDeSituacaoSelecionado()))])]), _vm._v(" "), _c('li', [_vm._v("\n            Total de solicitações:\n            "), _c('span', [_vm._v(_vm._s(_vm.solicitacoes.length))])]), _vm._v(" "), _c('li', [_vm._v("\n            Impresso em:\n            "), _c('span', [_vm._v("\n              " + _vm._s(new Date().toLocaleDateString('pt-BR')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "valor-total"
  }, [_vm._v("\n          Total: "), _c('strong', [_vm._v(_vm._s(_vm.exibirComoMoeda(_vm.somatorioSubsidios)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns search buscar-solicitacoes no-print"
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.filtrarSolicitacoes.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base linha-de-filtros"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome do proponente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    attrs: {
      "id": "nome",
      "name": "nome",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex. Ana maria da Silva"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "construtora"
    }
  }, [_vm._v("Construtora")]), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "construtora",
      "name": "construtora",
      "opcoes": _vm.opcoesDeConstrutoras,
      "pesquisavel": "",
      "rotulo-sem-selecao": "Todas as construtoras"
    },
    model: {
      value: (_vm.construtoraId),
      callback: function($$v) {
        _vm.construtoraId = $$v
      },
      expression: "construtoraId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "projeto",
      "name": "projeto",
      "opcoes": _vm.opcoesDeProjetos,
      "rotulo-sem-selecao": "Todos os projetos"
    },
    on: {
      "selecionar": _vm.redefinirFiltrosDeBusca
    },
    model: {
      value: (_vm.projeto),
      callback: function($$v) {
        _vm.projeto = $$v
      },
      expression: "projeto"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "empreendimento"
    }
  }, [_vm._v("Empreendimento")]), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "empreendimento",
      "name": "empreendimento",
      "opcoes": _vm.opcoesDeEmpreendimentos,
      "desabilitado": _vm.carregandoEmpreendimentos,
      "rotulo-sem-selecao": _vm.carregandoEmpreendimentos ? 'Carregando...' : 'Todos os empreendimentos',
      "pesquisavel": ""
    },
    model: {
      value: (_vm.empreendimento),
      callback: function($$v) {
        _vm.empreendimento = $$v
      },
      expression: "empreendimento"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "numeroDoProcesso"
    }
  }, [_vm._v("Processo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroDoProcesso),
      expression: "numeroDoProcesso"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99/999.999/9999'),
      expression: "'99/999.999/9999'"
    }],
    attrs: {
      "id": "numeroDoProcesso",
      "name": "numeroDoProcesso",
      "type": "text",
      "maxlenght": "15",
      "placeholder": "XX/XXX.XXX/XXXX"
    },
    domProps: {
      "value": (_vm.numeroDoProcesso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroDoProcesso = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base linha-de-filtros"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpf),
      expression: "cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    staticClass: "campos-tamanho-pequeno",
    attrs: {
      "id": "cpf",
      "name": "cpf",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "000.000.000-00"
    },
    domProps: {
      "value": (_vm.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpf = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "cnpjDaConstrutora"
    }
  }, [_vm._v("CNPJ da construtora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpjDaConstrutora),
      expression: "cnpjDaConstrutora"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99.999.999/9999-99'),
      expression: "'99.999.999/9999-99'"
    }],
    attrs: {
      "id": "cnpjDaConstrutora",
      "name": "cnpjDaConstrutora",
      "type": "text",
      "placeholder": "00.000.000/0001-00"
    },
    domProps: {
      "value": (_vm.cnpjDaConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpjDaConstrutora = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "situacao"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "situacao",
      "name": "situacao",
      "opcoes": _vm.situacoes,
      "desabilitado": _vm.carregandoSituacoes,
      "rotulo-sem-selecao": _vm.carregandoSituacoes ? 'Carregando...' : 'Todas as situações',
      "rotulo-de-selecionados": _vm.rotuloDeSituacoesSelecionadas,
      "multiplo": "",
      "preservar-ordem": ""
    },
    scopedSlots: _vm._u([{
      key: "opcao",
      fn: function(ref) {
        var opcao = ref.opcao;

        return [_c('span', {
          class: ['tags', _vm.classeCssDaCor('tags', opcao.cor)]
        }, [_vm._v(_vm._s(opcao.texto))])]
      }
    }]),
    model: {
      value: (_vm.situacao),
      callback: function($$v) {
        _vm.situacao = $$v
      },
      expression: "situacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "cidade"
    }
  }, [_vm._v("Cidade do empreendimento")]), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "cidade",
      "name": "cidade",
      "opcoes": _vm.opcoesDeCidades,
      "desabilitado": _vm.carregandoCidades,
      "rotulo-sem-selecao": _vm.carregandoCidades ? 'Carregando...' : 'Todas as cidades',
      "pesquisavel": ""
    },
    on: {
      "selecionar": _vm.preservarEmpreendimentoAoTrocarCidade
    },
    model: {
      value: (_vm.cidade),
      callback: function($$v) {
        _vm.cidade = $$v
      },
      expression: "cidade"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    attrs: {
      "for": "periodo"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "range-separator": '  até  ',
      "format": 'DD/MM/YYYY',
      "type": "date",
      "range": "",
      "placeholder": "dd/mm/aaaa"
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1)]), _vm._v(" "), (_vm.errosDeValidacao.length > 0) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('div', {
    staticClass: "mensagem mensagem_cor-erro",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle mensagem__icone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mensagem__conteudo"
  }, [_c('ul', {
    staticClass: "mensagem__texto lista-de-erros-do-filtro"
  }, _vm._l((_vm.errosDeValidacao), function(erro) {
    return _c('li', {
      key: erro
    }, [_vm._v("\n                    " + _vm._s(erro) + "\n                  ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('mensagem-flutuante', {
    attrs: {
      "titulo": "Identificamos um erro:",
      "texto": _vm.erroDaConsulta,
      "estilo": "erro",
      "icone": "fa-info-circle",
      "mensagem-visivel": !!_vm.erroDaConsulta
    },
    on: {
      "close": function($event) {
        _vm.erroDaConsulta = null
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('div', {
    staticClass: "faixa-de-acoes-dos-filtros"
  }, [_c('button', {
    staticClass: "botao botao_cor-primaria",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), (_vm.existeAlgumFiltroPreenchido) ? _c('button', {
    staticClass: "botao botao_cinza botao_sem-preenchimento",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v("\n                Limpar busca\n              ")]) : _vm._e()])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.solicitacoes), function(solicitacao) {
    return _c('tr', {
      attrs: {
        "id": solicitacao.Id
      }
    }, [_c('td', _vm._l((solicitacao.Proponentes), function(proponente) {
      return _c('div', [_c('p', [_vm._v(_vm._s(proponente.Nome))]), _vm._v(" "), (proponente.Conjuge) ? _c('p', [_vm._v(_vm._s(proponente.Conjuge.Nome))]) : _vm._e()])
    }), 0), _vm._v(" "), _c('td', _vm._l((solicitacao.Proponentes), function(proponente) {
      return _c('div', [_c('p', [_vm._v(_vm._s(proponente.Cpf))]), _vm._v(" "), (proponente.Conjuge) ? _c('p', [_vm._v(_vm._s(proponente.Conjuge.Cpf))]) : _vm._e()])
    }), 0), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(solicitacao.Imovel.Empreendimento.Nome) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(solicitacao.Imovel.Endereco.Cidade.Nome) + "\n          ")]), _vm._v(" "), _c('td', [_c('div', {
      class: [
        'tags',
        _vm.classeCssDaCor(
          'tags',
          _vm.obterCorDoStatusDaSolicitacao(solicitacao.StatusDaSolicitacao)
        ) ]
    }, [_vm._v("\n              " + _vm._s(solicitacao.Status) + "\n            ")]), _vm._v(" "), (solicitacao.InformacoesDoPagamento) ? _c('span', {
      staticClass: "print"
    }, [_c('span', {
      staticClass: "mostrar-numero-da-ob"
    }, [_vm._v("Nº da OB:")]), _vm._v("\n              " + _vm._s(solicitacao.InformacoesDoPagamento.OrdemBancaria))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(solicitacao.DataDeUltimaAtualizacaoDeStatus) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "no-print"
    }, [_vm._v("\n            " + _vm._s(solicitacao.NumeroDoProcesso ? solicitacao.NumeroDoProcesso : '---') + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "no-print"
    }, [(solicitacao.InformacoesDoPagamento) ? [_c('div', [_vm._v(_vm._s(solicitacao.InformacoesDoPagamento.OrdemBancaria))]), _vm._v(" "), (solicitacao.InformacoesDoPagamento.OrdemBancariaComplementar) ? _c('div', [_vm._v("\n                " + _vm._s(solicitacao.InformacoesDoPagamento.OrdemBancariaComplementar) + "\n              ")]) : _vm._e()] : [_vm._v("---")]], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.exibirComoMoeda(solicitacao.Financiamento.SubsidioDaAgehab)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "no-print"
    }, [_c('div', {
      staticClass: "dropdown dropdown_direita"
    }, [_vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown__lista",
      attrs: {
        "aria-label": "Submenu"
      }
    }, [_c('li', {
      staticClass: "dropdown__item",
      on: {
        "click": function($event) {
          return _vm.abrirResumoDaSolicitacao(solicitacao.Id, solicitacao.ProjetoTipo)
        }
      }
    }, [_vm._m(3, true)]), _vm._v(" "), _c('li', {
      staticClass: "dropdown__item",
      on: {
        "click": function($event) {
          return _vm.visualizarComprovanteDaSolicitacao(solicitacao.Id, solicitacao.ProjetoTipo)
        }
      }
    }, [_vm._m(4, true)])])])])])
  }), _vm._v(" "), (_vm.solicitacoes.length === 0) ? _c('tr', [_vm._m(5)]) : _vm._e()], 2)]), _vm._v(" "), _c('paginacao', {
    attrs: {
      "paginaAtual": _vm.paginaAtual,
      "totalDePaginas": _vm.totalDePaginas,
      "totalDeRegistros": _vm.totalDeRegistros,
      "quantidadePorPagina": _vm.quantidadePorPagina,
      "exibirSemRegistros": ""
    },
    on: {
      "paginar": _vm.obterSolicitacoes
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos print has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imagens/logo-relatorio-retrato.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Proponente(s)")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Empreendimento")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Data da situação")]), _vm._v(" "), _c('th', {
    staticClass: "no-print"
  }, [_vm._v("Processo NUP")]), _vm._v(" "), _c('th', {
    staticClass: "no-print"
  }, [_vm._v("Operação bancária")]), _vm._v(" "), _c('th', [_vm._v("Subsídio")]), _vm._v(" "), _c('th', {
    staticClass: "no-print"
  }, [_c('span', {
    staticClass: "u-esconder-acessivel"
  }, [_vm._v("Ações")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "botao botao_cor-terciaria botao_sem-preenchimento botao_pequeno botao-de-acoes-da-linha",
    attrs: {
      "aria-haspopup": "true",
      "aria-label": "Ações da solicitação"
    }
  }, [_c('i', {
    staticClass: "far fa-ellipsis-vertical"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown__link"
  }, [_c('i', {
    staticClass: "far fa-gear dropdown__icone"
  }), _vm._v("\n                    Gerenciar\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown__link"
  }, [_c('i', {
    staticClass: "far fa-print dropdown__icone"
  }), _vm._v("\n                    Imprimir\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "estado-vazio estado-vazio_largura-grande"
  }, [_c('i', {
    staticClass: "far fa-empty-set estado-vazio__icone"
  }), _vm._v(" "), _c('h2', {
    staticClass: "estado-vazio__titulo"
  }, [_vm._v("Nenhum resultado encontrado")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bfd8baa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/ListaDeSolicitacoes.vue
// module id = 1123
// module chunks = 1